{
  "parties": "Partes",
  "create-assoc": "Crear asociación",
  "create": "Crear",
  "contact": "Contacto",
  "kind": "Tipo",
  "add-party": "Agregar parte",
  "first-name": "Nombre",
  "last-name": "Apellido",
  "email": "Email",
  "cancel": "Cancelar",
  "role": "Rol",
  "owner": "Propietario",
  "gender": "Género",
  "ssn": "NSS",
  "addresses": "Direcciones",
  "spouse": "Cónyuge",
  "buyers": "Compradores",
  "on": "En",
  "title": "Title",
  "POA": "POA",
  "order-id": "ID de la orden",
  "not-selected": "Selecciona una parte",
  "not-selected-label": "Elige una parte para ver sus roles, datos de reporte y asociaciones.",
  "search-through": "Busca entre todos los contactos existentes para agregarlos a la orden",
  "search-through-text": "Busca entre todos los contactos existentes para agregarlos a la orden o agrega uno nuevo desde Contactos.",
  "type-as-3-characters": "Escribe al menos 3 caracteres para empezar a buscar",
  "clear-filter": "Mostrar partes comunes",
  "show-known-parties": "Sugeridas",
  "on-this-order": "En esta orden",
  "assigned-to": "Asignada a {{partyName}} como {{linkedAs}}",
  "assigned-as": "Asignada {{partyName}} como {{linkedAs}}",
  "roleLabel": "Rol: {{role}}",
  "contactFoundInDocument": "Contacto encontrado en el documento: {{contact}}",
  "deletedRole": "Has eliminado el {{role}}",
  "contactSearchMessage": "Encontramos {{count}} coincidencias en contactos, selecciona una de ellas en el campo o busca cualquier contacto en el sistema escribiendo allí o puedes crear un nuevo contacto en el botón de abajo",
  "contactSearchMessageNoMatches": "Busca cualquier contacto en el sistema escribiendo allí o puedes crear un nuevo contacto en el botón de abajo",
  "undo": "Deshacer",
  "createContact": "Crear contacto",
  "noParties": "Sin partes",
  "exemptFrom1099": "Exento de 1099",
  "foreignPerson": "Persona extranjera",
  "declinesToProvideSSN": "Se niega a proporcionar NSS",
  "party": "Parte",
  "one-party": "1 parte",
  "parties-count": "{{count}} partes",
  "groups": "Grupos de partes",
  "sections": "Secciones de la parte",
  "all-parties": "Todas las partes",
  "no-parties-yet": "Aún no hay partes",
  "no-parties-label": "Usa Agregar parte para vincular la primera parte a esta orden.",
  "no-parties-group": "No hay partes en este grupo",
  "load-error": "No pudimos cargar las partes de esta orden.",
  "contact-load-error": "No pudimos cargar la información de este contacto.",
  "party-not-found": "Esta parte ya no está en esta orden",
  "party-not-found-label": "Es posible que se haya eliminado. Vuelve a la lista de partes para continuar.",
  "remove-party-title": "¿Eliminar la parte de esta orden?",
  "remove-party-subtitle": "{{name}} se eliminará como {{role}}. El contacto no se eliminará.",
  "remove-party-aria": "Eliminar a {{name}} como {{role}}",
  "remove-association-title": "¿Eliminar la asociación?",
  "remove-association-subtitle": "{{name}} ya no estará vinculada como {{linkedAs}} en esta orden.",
  "add-association": "Agregar asociación",
  "no-associations": "No hay partes vinculadas en esta orden",
  "linked-as": "Vinculada como {{role}}",
  "change-kinds-aria": "Cambiar roles de {{name}}",
  "reporting-options": "Opciones de reporte",
  "collapse-all": "Contraer todo",
  "expand-all": "Expandir todo",
  "collapse-role": "Contraer {{role}}",
  "expand-role": "Expandir {{role}}",
  "scroll-tabs-left": "Desplazar pestañas a la izquierda",
  "scroll-tabs-right": "Desplazar pestañas a la derecha",
  "filter-name-placeholder": "Filtrar por nombre, rol o padre",
  "filter-name-label": "Filtrar partes",
  "no-filter-results": "Ninguna parte coincide con tu búsqueda"
}
